"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../@hooks");
var _constants = require("../../@constants");
var _AllClauses = _interopRequireDefault(require("./components/AllClauses"));
var _Parts = _interopRequireDefault(require("./components/Parts"));
var _MenuTable = _interopRequireDefault(require("./components/MenuTable"));
require("../../@assets/sass/components/TermsAndConditions.scss");
function TermsAndConditionsPage(props) {
  var _useWhitelabel = (0, _hooks.useWhitelabel)(),
    loading = _useWhitelabel.loading,
    whitelabel = _useWhitelabel.whitelabel;
  var logoSrc = _constants.logosImages[props.app].logo;
  var logoAlt = _constants.logosImages[props.app].logoAlt;
  if (loading) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  var _ref = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel[props.app]) || {},
    _ref$emailDomain = _ref.emailDomain,
    emailDomain = _ref$emailDomain === void 0 ? 'taugor.com.br' : _ref$emailDomain;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "TermsAndConditions ".concat(props.app)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "TermsAndConditions-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "TermsAndConditions-container-columnLeft"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logoSrc,
    alt: logoAlt
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "TermsAndConditions-container-columnLeft-title"
  }, "Termo de Ades\xE3o"), /*#__PURE__*/_react["default"].createElement("h4", {
    className: "TermsAndConditions-container-columnLeft-subtitle"
  }, "Planos de Servi\xE7os Pr\xE9-Pago"), /*#__PURE__*/_react["default"].createElement(_MenuTable["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "TermsAndConditions-container-columnRight"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "TermsAndConditions-container-columnRight-title"
  }, "Novo Hamburgo, Rio Grande do Sul, 06 de Abril de 2023"), /*#__PURE__*/_react["default"].createElement(_Parts["default"], null), /*#__PURE__*/_react["default"].createElement(_AllClauses["default"], {
    emailDomain: emailDomain
  }))));
}
var _default = TermsAndConditionsPage;
exports["default"] = _default;